'use client';

import React from 'react';

import type { SubscriptionFlowActiveStep } from '@/features/plans/presentation/constants/subscription-flow-steps';
import {
  SUBSCRIPTION_FLOW_STEP_PAYMENT,
  SUBSCRIPTION_FLOW_STEP_PLAN,
  SUBSCRIPTION_FLOW_STEP_PROFILE,
} from '@/features/plans/presentation/constants/subscription-flow-steps';

const STEPS: { id: SubscriptionFlowActiveStep; label: string }[] = [
  { id: 1, label: SUBSCRIPTION_FLOW_STEP_PROFILE },
  { id: 2, label: SUBSCRIPTION_FLOW_STEP_PLAN },
  { id: 3, label: SUBSCRIPTION_FLOW_STEP_PAYMENT },
];

export interface SubscriptionFlowStepperProps {
  /** Etapa em que o usuário está (1–4). */
  activeStep: SubscriptionFlowActiveStep;
}

/**
 * Indicador horizontal das etapas: Perfil → Plano → Pagamento → Confirmação.
 * Estilo alinhado às telas de escolha de plano e verificação da assinatura (fundo escuro).
 */
export const SubscriptionFlowStepper: React.FC<SubscriptionFlowStepperProps> = ({
  activeStep,
}) => {
  return (
    <ol
      className="flex flex-wrap items-center justify-center gap-2 text-xs text-white/80 sm:text-sm"
      aria-label="Etapas"
    >
      {STEPS.map((step, index) => {
        const done = activeStep > step.id;
        const current = activeStep === step.id;
        return (
          <React.Fragment key={step.id}>
            {index > 0 ? (
              <span className="text-white/40" aria-hidden>
                →
              </span>
            ) : null}
            <li
              className={`flex items-center gap-1.5 ${
                current ? 'font-medium text-white'
                : done ? 'text-white/80'
                : 'text-white/60'
              }`}
            >
              {done ? (
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-white/20 text-white text-xs font-semibold">
                  ✓
                </span>
              ) : current ? (
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-cyan/40 text-white text-xs font-semibold">
                  {step.id}
                </span>
              ) : (
                <span className="flex h-6 w-6 items-center justify-center rounded-full bg-white/10 text-white/70 text-xs font-semibold">
                  {step.id}
                </span>
              )}
              {step.label}
            </li>
          </React.Fragment>
        );
      })}
    </ol>
  );
};
